module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Stock":"Lager"}}')
  delete Component.options._Ctor
}
